<template>
    <div class="rptdesign_homeBox"  id="rptdesign_homeBox">
        <!--    左侧-->


        <div class="contentLeft">
            <reportList  ref="rptlist" @loadRptList="loadRptList"  :rptlist="rptList"  @handleNodeClick="selectedReport" ></reportList>
            <reportdialog  ref="mydialog"   ></reportdialog>
        </div>

            <div class="contentRight" >
                 <spread-edit ref="spread_Edit" :spdata="spData" :argdata="argData" :spparm="parmData" :spview="spView" > </spread-edit>
            </div>

            <input type="file" style="display:none"  name="upload_file" ref="upload_file" id="upload_file" @change="importFile"/>


    </div>


</template>

<script>
    // import * as API from "./api"


    import * as jUtil from '@/utils/gcExcelJs.js';
    import $ from 'jquery';
    import reportList from "./reportList"; // 左侧-模块
    import reportdialog from "@/components/dialog"; // dialog
     import spreadEdit from "./spread"; // spread

    export default {
        name: "reportDesign",
        components: {
            reportList,
            reportdialog,
            spreadEdit,
        },

        data() {
            return {
                spData:{},
                spView:{},
                rptJson:{},
                rptList:[],
                rptParm:{fid:"",file_json:"",file_type:"rpt",filename:""},
                parmData:{},
                argData:{},
                dataInfo:{},
                sets:{},
            };
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },

        activated(){
            this.onResize();
        },


        mounted() {
            this.onResize();

        },

        methods: {

            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                // $("#rptdesign_homeBox").height(n.h);
                //  $("#rptdesign_homeBox").width(n.w);
               //  $('.contentRight').width($("#rptdesign_homeBox").width() - $('.contentLeft').width() - 5 );
                $('.contentRight').width(n.w  - $('.contentLeft').width() - 5 );
                $('.contentRight').height(n.h   );
                $('.contentLeft').height(n.h   );
//                $("#rptdesign_homeBox").css.top=0;
                this.$refs.spread_Edit.onResize();
           },
            selectedReport(item){
                this.rptParm= {
                    fid:item.path,
                    filename:item.name,
                };
               this.loadReport();
            },
            newTemplate(type){

                    this.rptParm.fid="";
                    this.rptParm.filename="";

                    if (type==0) {
                        this.parmData = {parm:{},ds:{},info:{name:this.$t('report_untitled')}};

                        this.spData = {set:{parm:{},ds:{},info:{name:this.$t('report_untitled')}}};
                        this.$refs.rptlist.setParmDetail(this.parmData,this.parmData);
                    }
                    else{
                        this.spData.set.info.name=this.spData.set.info.name+"_copy";
                        this.$refs.rptlist.setParmDetail(this.spData.set,this.parmData);

                    }
                 },
            //打开报表模板 item:left tree node
            async  loadReport(){
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                let res = await jUtil.loadReportTemplate(this.rptParm);
                if (res.code==1) {
                    loading.close();
                    var sdata={};
                    sdata.template=res.hasOwnProperty("template")?res.template:res;
                    sdata.set=res.hasOwnProperty("set")?res.set:{};
                    sdata.isedit=false;
                    this.spData=sdata;
                    this.parmData={};
                    this.$refs.rptlist.setParmDetail(res.set,this.parmData);
                }
                else {
                    loading.close();
                           this.$refs.mydialog.showDialog({text:this.$t('report_report_loading_failed')+"!("+res.message+")"});}



            },
            //load
            async  loadRptList() {
                let _this=this;
                let res = await jUtil.loadReportAllList(this.rptParm);

                if (res.code==1) {
                    _this.rptList=res.data;
                    this.$refs.rptlist.setRptList(this.rptList);
                }
                else {
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_report_retrieval_failed')+"!("+res.message+")",info:res.error});
                }
            },
            //save报表模板
            async  saveTemplateToSvr(sJson) {
                if (sJson.set.info==null || sJson.set.info.name==null ||sJson.set.info.name==""){this.$refs.mydialog.showDialog({type:"error",text:this.$t('state_save_failed'),info:this.$t('report_report_name_not_set')});return;}
                const fd =this.rptList.findIndex(item=>(item.path!=this.rptParm.fid && item.label==sJson.set.info.name));
                if (fd!=-1) {this.$refs.mydialog.showDialog({type:"error",text:this.$t('state_save_failed'),info:this.$t('report_report_name')+"["+sJson.set.info.name+"],"+this.$t('report_the_system_already_exists')});return;}
                this.rptParm.file_json=sJson;
                this.rptParm.filename=sJson.set.info.name;
                if (sJson.set.info.hasOwnProperty("tag")) this.rptParm.vc_tag=sJson.set.info.tag;
                if (sJson.set.info.hasOwnProperty("code")) this.rptParm.code=sJson.set.info.code;
                let res = await jUtil.saveReportTemplate(this.rptParm);
                if (res.code==1) {
                    this.$message.success(this.$t('report_report_saved_successfully'));
                    //this.$refs.rptlist.setParmDetail(sJson.set,{});
                    let index = -1;
                        this.rptList.findIndex(item=>{if(item.path==this.rptParm.fid){
                        item.label=this.rptParm.filename;
                        item.name=this.rptParm.filename;
                        index=1;}
                    });
                    if (index==-1) {
                        let ob = {
                            label: this.rptParm.filename,
                            name: this.rptParm.filename,
                            id: res.data.i_id,
                            path: res.data.filenewname
                        };
                        this.rptParm.fid=res.data.filenewname;
                        this.rptList.push(ob);
                        this.$refs.rptlist.selectRptNode(res.data.i_id);
                       }
                }
                else {
                     this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_report_loading_failed')+"!("+res.message+")",info:res.error});
                }
            },
            //delete报表模板
             deleteTemplate(sJson) {
                 if (sJson.info.locked){this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_deletion_failed'),info:this.$t('report_report_locked')});return;}

                 let _this=this;
                if (!this.rptParm.hasOwnProperty('fid') || this.rptParm.fid=="") return;
                     this.$confirm(this.$t('report_this_operation_will_permanently_delete_the_file_do_you_want_to_continue'),this.$t('tips_prompt'),{confirmButtonText:this.$t('button_sure'),cancelButtonText:this.$t('button_cancel'),type:'warning'
                    }).then( async()=>{

                            let res = await jUtil.deleteReportTemplate(this.rptParm);
                            if (res.code==1) {
                                //this.$refs.mydialog.showDialog({text:this.$t('report_report_deleted_successfully')});
                                this.$message.success(this.$t('report_report_deleted_successfully'));
                                const index=_this.rptList.findIndex((item=>item.path==_this.rptParm.fid));
                                if (index!==-1){_this.rptList.splice(index,1);}
                                _this.$refs.spread_Edit.setFile('new');
                            }
                            else {
                                this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_report_deletion_failed')+"!("+res.message+")",info:res.error});
                            }
                            }).catch(()=>{});

            },
                //打开报表模板 item:left tree node
            async  loadReportData(){
                let _this=this;
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                let res = await jUtil.loadReportData(this.rptParm);
                if (res.code==1) {

                    loading.close();
                    this.spView=res.gcExcel;
                    _this.parmData = {parm: res.set.parm};
                    _this.argData = res.argdata;

                    if (!res.argdata.hasOwnProperty("initParm")) {
                        this.$refs.rptlist.setParmDetail(res.set, res.parmdata, res.argdata);
                    }
                      }
                else
                {
                    loading.close();
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_report_loading_failed')+"!("+res.message+")",info:res.error});

                }


            },



            importFile() {

                var file = document.getElementById("upload_file").files[0];
                var fileName = file.name;
                var index = fileName.lastIndexOf('.');
                var fileExt = fileName.substr(index + 1).toLowerCase();
                if (fileExt === 'json' || fileExt === 'ssjson' ||fileExt === 'rpt') {
                    this.importFromJSON(file);
                } else
                if (fileExt === 'xlsx' || fileExt === 'xls') {
                    this.importFromExcel(file);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_invalid_file'),info:this.$t('report_please_select_an_excel_template_file')});
                }
                $("#upload_file").val("");
            },


            importFromJSON(file) {
                var _this=this;
                function importSuccessCallback(responseText) {
                    _this.parmData={};
                    var json=JSON.parse(responseText);
                    var spreadJson = json.template;
                  //  if ( spreadJson.hasOwnProperty("set")) app.load( spreadJson.set);
                    _this.$refs.spread_Edit.spread.fromJSON(spreadJson);
                    _this.$refs.spread_Edit.sets=json.set;
                   _this.$refs.rptlist.setParmDetail(json.set,_this.parmData);
                    _this.$refs.jview.jsonDataLoad({message:this.$t('report_the_file_opens_normally')});
                }

                var reader = new FileReader();
                reader.onload = function () {
                    importSuccessCallback(this.result);
                };
                reader.readAsText(file);
                return true;
            },

            //上传EXCEL
            importFromExcel(file){

                this.$refs.spread_Edit.excelIo.open(file, (json) => {
                    let workbookObj = json;
                    this.$refs.spread_Edit.spread.fromJSON(workbookObj);

                }, function (e) {
                    var err="";
                    if (e.errorCode === 0 || e.errorCode === 1) {
                        err="invalidImportFile";
                    } else if (e.errorCode === 2) {
                        err='passwordError';
                    } else if (e.errorCode === 3) {
                        err=e.toString();
                    }
                    _this.$refs.mydialog.showDialog({text:this.$t('report_file_opening_failed')+"!("+err+")"});

                });
            },

            //保存EXCEL
            saveTemplateToExcel(){
                //生成时间戳
                var fileName = new Date().getTime() + '.xlsx';
                var json =this.$refs.spread_Edit.spread.toJSON({includeBindingSource: true});
                this.$refs.spread_Edit.excelIo.save(json, (blob) => {
                    saveAs(blob, fileName);
                }, function (e) {
                    // console.log(e);
                });
            },
            //前台保存
            saveTemplateToJson(sJson){
                //生成时间戳
                var fileName = new Date().getTime() + '.json';
                var jsontext = JSON.stringify(sJson);

                saveAs(new Blob([jsontext], {type: "text/plain;charset=utf-8"}), fileName);
            },
            //保存报表
            saveFileToSvr(){
                //生成时间戳

                // var fileName = new Date().getTime() + '.json';
                // var json = this.spread.toJSON({includeBindingSource: true});
                // var jsontext = JSON.stringify(json);
                // //前台保存
                // saveAs(new Blob([jsontext], {type: "text/plain;charset=utf-8"}), fileName);
                // //保存后台
                // let formData = new FormData();
                // // var thefile = document.getElementById("upload_file").files[0];
                // var thefile = this.filesdata.version;
                // formData.append("file", thefile);
                // axios.post('/admin/excelup/doImport', formData).then(function (response) {
                //     alert("模板保存成功");
                // }).catch(function (error) {
                //     alert("上传失败");
                //     //console.log(error);
                // });
            },
            openTemplate() {

                this.$refs.upload_file.dispatchEvent(new MouseEvent('click'));
            },


            getFile(){
                var _this=this;
                var file = document.getElementById("selectfile").files[0];
                this.$refs.spread_Edit.excelIo.open(file, function (json) {
                    var workbookObj = json;
                    _this.$refs.spread_Edit.spread.fromJSON(workbookObj);
                    if(workbookObj.hasOwnProperty("set")){
                        _this.$refs.jeditor.jsonDataLoad(wrorkbookObj.set);
                        this.$refs.rptlist.setParmDetail(workbookObj.set,{});
                       }
                }, function (e) {
                    var err="";
                    if (e.errorCode === 0 || e.errorCode === 1) {
                      err="invalidImportFile";
                    } else if (e.errorCode === 2) {
                       err='passwordError';
                    } else if (e.errorCode === 3) {
                     err=e.toString();
                    }
                    _this.$refs.mydialog.showDialog({text:this.$t('report_file_opening_failed')+"!("+err+")"});

                });
            },


            btn(id){
                let id_clicked=id.split("-");
                let sid=id_clicked[1];
                switch (id_clicked[0]) {
                    case 'run':
                       let args=this.$refs.rptlist.getArgsObj();
                       // if (args.hasOwnProperty("initParm")) delete args.initParm;
                        // console.log('r',args);

                       this.rptParm.arg=args;
                       // if (this.rptParm.hasOwnProperty("arg")) delete this.rptParm.args;
                       //  this.rptParm.level=1;
                        this.loadReportData();
                        break;
                    case 'view':
                        // let args=this.$refs.rptlist.getArgsObj();
                        // if (args.hasOwnProperty("initParm")) delete args.initParm;
                        // console.log('r',args);

                        // this.rptParm.arg=args;
                        if (this.rptParm.hasOwnProperty("arg")) delete this.rptParm.args;
                        //  this.rptParm.level=1;
                        this.loadReportData();
                        break;
                    case 'collect':
                        $('#collect').hide();
                        $('#expend').show();
                        $('.contentLeft').hide();
                        $('.contentLeft').width(0);
                        this.onResize();
                        break;
                    case 'expend':
                        $('#expend').hide();
                        $('#collect').show();
                        $('.contentLeft').show();
                        $('.contentLeft').width(260);
                        this.onResize();

                        break;

                    case 'saveTemplateToSvr':
                        this.saveTemplateToSvr();
                        break;
                    case 'saveTemplateToExcel':
                         this.saveTemplateToExcel();
                        break;
                    case 'saveTemplateToJson':
                        this.saveTemplateToJson();
                        break;


                    case 'saveas':
                        this.$refs.spView.saveExcel();
                        break;
                    case 'savePDF':
                        this.$refs.spView.savePDF();
                        break;
                    case 'open':
                        this.openTemplate();
                        break;

                    default: break;
                }

            },
        },
    }
</script>


<style lang="scss" >

    .rptdesign_homeBox {
         margin-top: 0px;
        height: 100%;
        width: 100%;

        .contentLeft {
            float: left;
            width: 260px;
            height: calc(100% - 0px);
            border-bottom: 1px solid #d5d7da;
            border-right: 1px solid #d5d7da;
            z-index: 100;

        }

        .contentRight {
            float: left;
            height:calc(100% - 5px);
            width: calc(100% - 265px);
            border-bottom: 1px solid #d5d7da;
            z-index: 1000;
        }


    }





    .ul_list {
        height:40px;
         .li {
             margin-top:10px ;
            height: 20px;
            float: left;
            display: block;
        }
    }
</style>

